/**
 * Upgrades select form elements to nifty clickable star rating widgets.
 * @param {Array.<string>} selects
 * @param {string} starOffImgSrc
 * @param {string} starOnImgSrc
 */
function dnSetupStarRatings(selects, starOffImgSrc, starOnImgSrc) {
    // First, create a function for updating the rating spans.
    var updateRatingDisplay = function (ratingSpan, rating) {
        ratingSpan.select("img").each(function (img, i) {
            img.src = i + 1 <= rating ? starOnImgSrc : starOffImgSrc;
        });
    };
    
    $A(selects).each(function (sel) {
        // Use a span to hold the ratings star images.
        var ratingSpan = $E("span", { "class": "dnStarRating" });
        ratingSpan.setStyle({ "cursor": "pointer"});
        
        // Create the ratings span elements with the curent value.
        var curRating = sel.value ? parseInt(sel.value, 10) : 0;
        for (var i = 1; i <= 5; i++) {
            ratingSpan.insert( $E("img", {
                "src": i <= curRating ? starOnImgSrc : starOffImgSrc,
                "title": i == 1 ? "1 star" : i + " stars",
                "alt": i  // Keep the rating value in the alt attribute.
            }));
        }
        
        // Attach event handlers to the star images.
        ratingSpan.select("img").each(function (img) {
            img.observe("click", function (e) {
                sel.value = img.alt;
                updateRatingDisplay(ratingSpan, parseInt(this.alt, 10));
            });
        
            img.observe("mouseover", function (e) {
                if (this.dnStarRatingsMouseIn) return;
                this.dnStarRatingsMouseIn = true;
                updateRatingDisplay(ratingSpan, parseInt(this.alt, 10));
            });
            
            img.observe("mouseout", function (e) {
                this.dnStarRatingsMouseIn = false;
                updateRatingDisplay(ratingSpan, parseInt(sel.value, 10));
            })
        });
        
        // Hide the select and add the new ratings elements.
        $(sel).hide().insert({ "after": ratingSpan });
    });
};

// ---------------------------------------------------------------------

window["dnSetupStarRatings"] = dnSetupStarRatings;

// ---------------------------------------------------------------------